import Header from '../../components/Header';
import SidebarProfile from '../../components/SidebarProfile';
import RightSidebar from '../../components/RightSidebar';
import NewsFeed from '../../components/NewsFeed';

import styles from './NewsPage.module.css';

export default function NewsPage() {
  return (
    <div className={styles.container}>
      <Header />

      <main className={styles.main}>
        <div className={styles.sidebar}>
          <SidebarProfile />
        </div>

        <div className={styles.feed}>
          <NewsFeed />
        </div>

        <div className={styles.rightbar}>
          <RightSidebar />
        </div>
      </main>
    </div>
  );
}